import {InputBase, Paper, styled} from '@mui/material';
import {CustomStyledPaper} from './types';

export const StyledPaper = styled<CustomStyledPaper>(Paper)`
	padding: 3px 5px 3px 12px;
	gap: 8px;
	display: flex;
	align-items: center;
	width: 100%;

	${({theme}) => theme.name === 'hap' && 'border-radius: 21px;'}

	border: 1px solid ${({theme}) => theme.palette.other.outlineBorder};

	&:focus-within {
		border-color: ${({theme}) => theme.palette.other.progressBar};
	}
`;

export const StyledInputBase = styled(InputBase)`
	flex: 1;

	.MuiInputBase-input {
		padding-top: 5px;
		height: 24px;
	}
`;
